import { render } from "./PaypalPayment.vue?vue&type=template&id=6108f560&scoped=true"
import script from "./PaypalPayment.vue?vue&type=script&lang=js"
export * from "./PaypalPayment.vue?vue&type=script&lang=js"

import "./PaypalPayment.vue?vue&type=style&index=0&id=6108f560&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6108f560"]])

export default __exports__